import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { SecurityManager } from './app.sec.component';
@Component({
  providers: [SecurityManager],
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(private security: SecurityManager) {}



  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.component.ts